"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.channelDeepLink = exports.chatDeepLink = exports.messageDeepLink = exports.helpDeepLink = exports.tabDeepLink = exports.AGILE_HELP_PAGE_URL = exports.HELP_PAGE_URL = void 0;
// SEE: https://docs.microsoft.com/en-us/microsoftteams/platform/concepts/build-and-test/deep-links
const BASE_URL = "https://teams.microsoft.com/l";
const ENTITY_BASE_URL = `${BASE_URL}/entity`;
const MESSAGE_BASE_URL = `${BASE_URL}/message`;
const HELP_PAGE_ENTITY_ID = "b7a6c663-f0c2-43cf-b2a1-d0992340b519";
const AGILE_HELP_PAGE_ENTITY_ID = "b7a6c663-f0c2-43cf-b2a1-d0992340b518";
exports.HELP_PAGE_URL = "https://www.polly.ai/help/microsoft-teams";
exports.AGILE_HELP_PAGE_URL = "https://www.polly.ai/help/microsoft-teams-agile";
const HELP_PAGE_LABEL = "Help";
const tabDeepLink = (params) => {
    const { appId, entityId, entityLabel, channelId } = params;
    const context = encodeURIComponent(JSON.stringify({ channelId }));
    const label = encodeURIComponent(entityLabel);
    return `${ENTITY_BASE_URL}/${appId}/${entityId}?theme={theme}&label=${label}&context=${context}`;
};
exports.tabDeepLink = tabDeepLink;
const helpDeepLink = (params) => {
    const { appId, applicationType } = params;
    const entityId = applicationType === "agile" ? AGILE_HELP_PAGE_ENTITY_ID : HELP_PAGE_ENTITY_ID;
    const webUrl = encodeURIComponent(applicationType === "agile" ? exports.AGILE_HELP_PAGE_URL : exports.HELP_PAGE_URL);
    const label = encodeURIComponent(HELP_PAGE_LABEL);
    return `${ENTITY_BASE_URL}/${appId}/${entityId}?theme={theme}&webUrl=${webUrl}&label=${label}`;
};
exports.helpDeepLink = helpDeepLink;
const messageDeepLink = (params) => {
    const { threadId, messageId, tenantId, parentMessageId } = params;
    if (parentMessageId) {
        return `${MESSAGE_BASE_URL}/${threadId}/${messageId}?tenantId=${tenantId}&parentMessageId=${parentMessageId}`;
    }
    return `${MESSAGE_BASE_URL}/${threadId}/${messageId}?tenantId=${tenantId}`;
};
exports.messageDeepLink = messageDeepLink;
const chatDeepLink = (userUPNs, topicName, messageText) => {
    let link = `${BASE_URL}/chat/0/0?users=${userUPNs.join(",")}`;
    if (topicName) {
        link += `&topicName=${encodeURIComponent(topicName)}`;
    }
    if (messageText) {
        link += `&message=${encodeURIComponent(messageText)}`;
    }
    return link;
};
exports.chatDeepLink = chatDeepLink;
const channelDeepLink = ({ channelId, channelName }) => {
    if (channelId.includes("meeting_")) {
        return `https://teams.microsoft.com/_#/conversations/${channelId}?ctx=chat`;
    }
    return `https://teams.microsoft.com/_#/conversations/${encodeURIComponent(channelName)}?threadId=${channelId}&ctx=channel`;
};
exports.channelDeepLink = channelDeepLink;
//# sourceMappingURL=deepLink.js.map